const images = require.context("../images", true)
const audios = require.context("../audios", true)

const content = {
	imageContainerClass: "bg-extended pos-1 bg-white",
	images: [
		{
			src: images("./bag_with_flower-p10.gif"),
			class: "image-one imgbox-md bagFlower",
			imgdiv: "imageCover",
		},
	],
	texts: [
		{
			textDivClass: "story-text text-center text-p11 textbox textbox-ban",
			textIndivData: [
				{
					textData: "“आहा! कस्तो राम्रो ब्याग।”",
					textClass: "fz-5 m-0 one-line text-p11a textStyles",
					timestamps: [{ start: 0 }, { start: 1.1 }, { start: 1.6 }, { start: 2.1 }],
				},
			],
		},
	],
	sounds: [
		{
			url: audios("./soundEffect/successBell.ogg"),
			delay: 1500,
			isBg: true,
			loop: false,
			volume: 0.8,
		},
		{
			url: audios("./s11.ogg"),
			delay: 4000,
		},
	],
}

export default content
